module.exports = __webpack_public_path__ + "img/VP6000-image.62b30b7b.jpeg";